
<style lang="less" scoped>
.app {
  background: #f2f2f2;
  min-height: calc(100vh - 50px);
  .demo-contact-card {
    .van-popup {
      height: 100%;
      background-color: #f2f2f2;
    }
  }
  .address {
    .van-cell__left-icon {
      color: #ffc053;
    }

    .van-contact-card::before {
      background: repeating-linear-gradient(
        -45deg,
        #ffc053 0,
        #ff6c6c 20%,
        transparent 0,
        transparent 25%,
        gray 0,
        gray 45%,
        transparent 0,
        transparent 50%
      );
      background-size: 80px;
    }
  }
  .van-address-list {
    padding: 0;
    .van-tag--danger {
      background: #ffc053;
      padding: 2px 10px;
    }
    .van-address-list__bottom,
    .van-radio__icon {
      display: none;
    }
    .van-radio-group {
      position: relative;
      &::before {
        position: absolute;
        right: 0;
        bottom: 0;
        left: 0;
        height: 2px;
        background: repeating-linear-gradient(
          -45deg,
          #ffc053 0,
          #ff6c6c 20%,
          transparent 0,
          transparent 25%,
          gray 0,
          gray 45%,
          transparent 0,
          transparent 50%
        );
        background-size: 80px;
        content: "";
      }
    }
  }
}

.items {
  .van-card {
    background: #fff;
    font-size: 14px;
    margin: 0;
    .van-card__thumb {
      width: 60px;
      height: 60px;
    }
  }
  .van-card:first-child {
    margin-top: 10px;
  }

  .van-card__content {
    justify-content: space-evenly;
    .van-card__price {
      color: red;
      transform: scale(1.2);
    }
  }
  .van-cell-group {
    .van-cell {
      padding-top: 5px;
      .van-cell__title {
        color: #9f9f9f;
        // padding-left: 10px;
      }
      .van-cell__value,
      .van-cell__right-icon {
        color: #434343;
      }
    }
    .van-cell:first-child::before {
      position: absolute;
      box-sizing: border-box;
      content: " ";
      pointer-events: none;
      right: 0;
      top: 0;
      left: 16px;
      border-bottom: 1px solid #ebedf0;
      -webkit-transform: scaleY(0.5);
      transform: scaleY(0.5);
    }
  }
}

.select-cell {
  .oldTotal {
    .van-cell__value {
      text-decoration: line-through;
    }
  }
  margin-top: 5px;
  .van-cell__title {
    color: #696969;
    // padding-left: 10px;
  }
  .van-cell__value {
    color: #434343;
    font-size: 16px;
  }
  .total {
    .van-cell__value {
      color: red;
    }
  }
}

.sub-btn {
  width: 90%;
  margin: 15px 0;
  margin-left: 5%;

  .van-button__content {
    color: black;
  }
}
.van-coupon-list {
  .van-coupon__head {
    color: #ffc053;
  }
  .van-coupon--disabled {
    .van-coupon__head {
      color: #646566;
    }
  }
  .van-tab--active {
    color: #ffc053;
  }
  .van-tabs__line {
    background: #ffc053;
  }
  .van-button--danger {
    background: #ffc053;
    border: 1px solid #ffc053;
  }
}

.address-box {
  background: #fff;
  display: flex;
  padding: 15px;
  position: relative;
  .address-left,
  .address-right {
    display: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .address-mid {
    padding-left: 15px;
    flex: 5;
    .shopname,
    .name {
      font-weight: 500;
    }
  }
  &::before {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    height: 2px;
    background: repeating-linear-gradient(
      -45deg,
      #ffc053 0,
      #ff6c6c 20%,
      transparent 0,
      transparent 25%,
      gray 0,
      gray 45%,
      transparent 0,
      transparent 50%
    );
    background-size: 80px;
    content: "";
  }
}
/deep/.van-popup{
.van-coupon__amount,.van-coupon__condition,.van-coupon__head{
    color: #ffc053;
  }
  .van-icon-success{
        color: transparent;
    border: 1px solid #c8c9cc;
  }
  .van-checkbox__icon--checked .van-icon-success,.van-button--danger{
    color:#fff!important;
        border-color: #ffc053!important;
    background-color: #ffc053!important;
  }
  .van-button--danger{
    color: black;
  }
}
.payType{
  display: flex;
  justify-content: space-around;
  width: 100%;
  font-size: 18px;  
  font-weight:500 ;
}
</style>
<template>
  <div class="app">
    <div v-if="!showPage">
      <van-loading size="24px" vertical>加载中...</van-loading>
    </div>
    <div v-else>
      <div class="address">
        <van-contact-card
          v-if="!address.id"
          type="add"
          :name="currentContact.name"
          :tel="currentContact.tel"
          @click="toAddress"
          add-text="选择或添加新地址"
        />
        <div v-else class="address-box">
          <div class="address-left">
            <!-- <van-icon name="map-marked"   color="#ffc053" /> -->
            <van-icon name="map-marked" size="30" color="#ffc053" />
          </div>
          <div class="address-mid">
            <!-- <span class="shopname"></span><br> -->
            <span class="name">[{{address.ShopName}}] {{address.Name}} {{address.Phone}}</span>
            <br />
            <span
              class="user-address"
            >{{address.Region}}{{address.Address}}{{address.AddressDetail}}</span>
          </div>
          <div class="address-right">
            <van-icon name="arrow" color="gray" @click="toAddress" />
          </div>
        </div>
      </div>

      <div class="items">
        <van-card
          v-for="(item,index) in list"
          :key="index"
          :price="(item.Price/100).toFixed(2)"
          :desc="`${item.OptionWeight}${item.OptionUnit}`"
          :title="item.OptionName"
          :thumb="item.OptionImage"
          :num="item.Num"
        />
        <van-cell-group :border="false">
          <van-cell :border="false" title="积分抵扣" value="暂无可用" is-link />
          <!-- 优惠券单元格 -->
          <!-- <van-coupon-cell
            :coupons="coupons"
            :chosen-coupon="chosenCoupon"
            @click="showCouponList = true"
          /> -->
        </van-cell-group>
      </div>

      <!-- 优惠券列表 -->
      <van-popup
        v-model="showCouponList"
        round
        position="bottom"
        style="height: 90%; padding-top: 4px;"
      >
        <van-coupon-list
          :show-exchange-bar="false"
          :coupons="coupons"
          :chosen-coupon="chosenCoupon"
          @change="onChange"
          @exchange="onExchange"
        />
      </van-popup>

      <div class="select-cell" :border="false">
        <van-cell-group>
          <van-cell :border="false" title="运费" value="￥0.00" />
          <van-cell :border="false" title="商家优惠券" :value="`-￥${CouponsTotalStore/100}`" />
          <van-cell :border="false" title="平台红包" :value="`-￥${CouponsTotalYFY/100}`" />
          <van-cell :border="false" class="oldTotal" title="原价" :value="`￥${(ItemTotal/100).toFixed(2)}`" />
          <van-cell :border="false" class="total" title="实付金额" :value="`￥${(Total/100).toFixed(2)}`" />
          <van-field v-model="message" type="textarea" placeholder="这里可以留言哦" />
        </van-cell-group>
        <van-field name="radio" label="支付方式">
          <template #input>
            <van-radio-group class="payType" v-model="radio">
              <van-radio checked-color="#ffc053" shape="square" name="在线支付">微信支付</van-radio>
              <van-radio checked-color="#ffc053" shape="square" name="货到付款">货到付款</van-radio>
            </van-radio-group>
          </template>
        </van-field>
      </div>

      <van-button color="#ffc053" class="sub-btn" @click="addOrder" type="primary" size="large">提交订单</van-button>
    </div>
  </div>
</template>

<script>
import {
  ContactCard,
  ContactList,
  ContactEdit,
  Popup,
  Card,
  AddressList,
  Cell,
  CellGroup,
  CouponCell,
  Icon,
  CouponList,
  Field,
  Empty,
  RadioGroup,
  Radio,
  Button
} from "vant";
import api from "../../api/cartDetail";
export default {
  components: {
    [ContactCard.name]: ContactCard,
    [ContactList.name]: ContactList,
    [ContactEdit.name]: ContactEdit,
    [AddressList.name]: AddressList,
    [Empty.name]: Empty,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Popup.name]: Popup,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [Button.name]: Button,
    [CouponCell.name]: CouponCell,
    [CouponList.name]: CouponList,
    [Field.name]: Field,
    [Icon.name]: Icon,
    [Card.name]: Card
  },
  data() {
    return {
      query: {},
      chosenContactId: null,
      editingContact: {},
      showList: false,
      showCouponList: false,
      showEdit: false,
      isEdit: false,
      message: "",
      address: {},
      radio: "在线支付",
      chosenAddressId: "",
      addresslist: [],
      list: [],
      showPage: false,
      userInfo: {},
      ItemTotal: 0,
      Total:0,
      chosenCoupon: -1,
      coupons: [
        // {
        //   available: 1,
        //   condition: "满1包优惠￥12",
        //   reason: "",
        //   value: 150,
        //   name: "天香源丝苗米单包券",
        //   startAt: 1489104000,
        //   endAt: 1514592000,
        //   valueDesc: "12",
        //   unitDesc: "元"
        // }
      ]
    };
  },
  computed: {
    mockContact() {
      return {
        name: "1122332",
        tel: "13000000000",
        id: 0,
        isDefault: 1
      };
    },
    // cardType() {
    //   return this.chosenContactId !== null ? "edit" : "add";
    // },
    currentContact() {
      const id = this.chosenContactId;
      return id !== null ? this.list.filter(item => item.id === id)[0] : {};
    }
  },
  created() {
    this.userInfo = this.$store.state.userInfo;
    console.log(this.userInfo);
    let addressId = this.$route.query.addressId;
    console.log(addressId);
    if (addressId) {
      this.getAddress(addressId);
    } else {
      this.getAddress();
    }

    api.cartItemList2({Status:1}).then(res => {
      if (res.status == 0 && res.result) {
        let Total=0
        let ItemTotal=0
        res.result.forEach(element => {
          Total+=element.Price*element.Num
          ItemTotal+=element.Price*element.Num
        });
        this.ItemTotal=ItemTotal
        this.list = res.result;
        this.CouponsTotalStore=res.CouponsTotalStore
        this.CouponsTotalYFY=res.CouponsTotalYFY

        this.Total=Total-this.CouponsTotalYFY-this.CouponsTotalStore
      }
      this.showPage = true;
    });
  },
  beforeMount() {
    this.query = this.$route.query;
  },
  mounted() {
    console.log("this.query", this.query);
  },
  methods: {
    onAdd() {
      this.editingContact = { id: this.list.length };
      this.isEdit = false;
      this.showEdit = true;
    },
    onEdit(item) {
      this.isEdit = true;
      this.showEdit = true;
      this.editingContact = item;
    },
    onSelect() {
      this.showList = false;
    },
    onSave(info) {
      this.showEdit = false;
      this.showList = false;
      if (this.isEdit) {
        this.list = this.list.map(item => (item.id === info.id ? info : item));
      } else {
        this.list.push(info);
      }
      this.chosenContactId = info.id;
    },
    onDelete(info) {
      this.showEdit = false;
      this.list = this.list.filter(item => item.id !== info.id);
      if (this.chosenContactId === info.id) {
        this.chosenContactId = null;
      }
    },
    onChange(index) {
      this.showCouponList = false;
      this.chosenCoupon = index;
    },
    onExchange(code) {
      console.log(code);
      console.log(1);
      //   this.coupons.push(coupon);
    },
    toAddress() {
      this.$router.replace({
        name: "address",
        query: {
          type: "order"
        }
      });
    },
    addOrder() {
      console.log();
      let params = {
        addressId: this.address.id,
        PayType: this.radio,
        PaidBy: this.radio == "货到付款" ? "到付" : "微信支付",
        Comment: this.message
      };
      // 测试
      let host=window.location.host
      console.log('host:',window.location.host)
      if(host=='jmytest.riceyfy.com'){
        api.orderAddTest(params).then(res => {
          if (res.status == 0 ) {
            console.log(res)
            this.$router.replace({
              name: "order",
              query: {
                orderId: res.result
              }
            });
          }
        });
      } else {
        api.orderAdd2(params).then(res => {
        if (res.status == 0 ) {
          console.log(res)
          this.$router.replace({
            name: "order",
            query: {
              orderId: res.result
            }
          });
        }
      });
      }

    },
    getAddress(id) {
      if (id) {
        api.address({ id }).then(res => {
          if (res.status == 0) {
            this.address = res.result;
          }
        });
      } else {
        api.address({ Status: "on" }).then(res => {
          if (res.status == 0 && res.result) {
            this.address = res.result;
          } else {
            this.address = {};
          }
        });
      }
    }
  }
};
</script>
